import React from 'react';
import classnames from 'classnames';

const LearnMore = ({ onClick, href, text = 'Learn More', className }) => {
  const buttonClassName = classnames('learn-more-button', className);
  return href ? (
    <a className={buttonClassName} target="_blank" href={href}>
      {text}
    </a>
  ) : (
    <button className={buttonClassName} onClick={onClick}>
      {text}
    </button>
  );
};

export default LearnMore;
